import { useState } from "react";
import axios from "axios";

function EditClient({client,onClose}){

const [username,setUsername]=useState(
client.username
);

const [email,setEmail]=useState(
client.email
);

const [companyName,setCompanyName]=useState(
client.company_name
);

const [contactPerson,setContactPerson]=useState(
client.contact_person
);

const [mobile,setMobile]=useState(
client.mobile
);

const [address,setAddress]=useState(
client.address || ""
);

const [city,setCity]=useState(
client.city || ""
);

const [state,setState]=useState(
client.state || ""
);

const [pinCode,setPinCode]=useState(
client.pin_code || ""
);

const updateClient=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const response=await axios.post(

"https://saleupcall.com/api/Client/edit-client.php",

{

id:client.id,

username,
email,

company_name:companyName,
contact_person:contactPerson,
mobile,
address,

city,
state,
pin_code:pinCode

},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Client Updated"
);

onClose();

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={updateClient}>

<div className="row">

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Username"
value={username}
onChange={(e)=>
setUsername(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Email"
value={email}
onChange={(e)=>
setEmail(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Company Name"
value={companyName}
onChange={(e)=>
setCompanyName(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Contact Person"
value={contactPerson}
onChange={(e)=>
setContactPerson(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Mobile"
value={mobile}
onChange={(e)=>
setMobile(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="City"
value={city}
onChange={(e)=>
setCity(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="State"
value={state}
onChange={(e)=>
setState(
e.target.value
)
}
/>

</div>

<div className="col-md-6 mb-3">

<input
className="form-control"
placeholder="Pin Code"
value={pinCode}
onChange={(e)=>
setPinCode(
e.target.value
)
}
/>

</div>

<div className="col-md-12 mb-3">

<textarea
className="form-control"
placeholder="Address"
value={address}
onChange={(e)=>
setAddress(
e.target.value
)
}
/>

</div>

</div>

<button
className="btn btn-primary"
>

Update

</button>

</form>

);

}

export default EditClient;